<template>
  <f7-page login-screen id="reset-password-screen">
    <f7-login-screen-title>
      <img src="/static/images/logos/private-gym/logo-cropped.svg" style="width: 80%; max-width:250px; opacity: 1;" class="m-3 w-80">
    </f7-login-screen-title>
    <!--
      `@submit.prevent`: the keyboard's action key (Enter on a laptop, the
      bottom-right key on an Android keyboard) submits the form the field sits
      in, and framework7-vue's f7-list forwards that native event when it has
      the `form` prop (list.js:73). The hidden submit button is what makes the
      browser submit at all: a form with two text fields and NO submit button
      has no implicit submission (HTML spec), which is why Enter did nothing
      on the Redmi (owner, 2026-09-06).
    -->
    <f7-list form class="list-strong list-outline list-dividers" @submit.prevent="signIn">
      <f7-list-input
          type="text"
          name="email"
          placeholder="Jouw email adres"
          :value="email"
          @input="email = $event.target.value"
      ></f7-list-input>
      <f7-list-input
          type="password"
          name="password"
          placeholder="Wachtwoord"
          :value="password"
          @input="password = $event.target.value"
      ></f7-list-input>
      <button type="submit" hidden aria-hidden="true" tabindex="-1">Log in</button>
    </f7-list>
    <f7-list class="list-strong list-outline list-dividers">
      <f7-list-button title="Log in" @click="signIn"></f7-list-button>
      <f7-block-footer>
        Lukt inloggen niet?<br/>
        <f7-link href="/auth/forgot-password">Klik hier om je wachtwoord te resetten</f7-link><br/>
        <!--            <f7-link href="/auth/reset-password">Klik hier om de wachtwoord reset code in te voeren</f7-link>-->
      </f7-block-footer>
    </f7-list>
  </f7-page>
</template>

<script>

export default {
  components: {
    //
  },

  props: {
    f7router: Object,
    f7route: Object,
  },

  mixins: [],

  data: function () {
    return {
      // Login screen data
      email: '',
      password: '',
    };
  },

  computed: {
    current_user_has_token() {
      return this.$store.getters['current_user/token'].length > 0;
    },
  },

  created() {
    if (this.current_user_has_token) {
      this.$store.dispatch('current_user/fetch');
    }
  },

  mounted() {
    //
  },

  methods: {
    signIn() {
      this.$store.dispatch('current_user/login', {
        email: this.email,
        password: this.password,
      }).then(response => {
        this.f7router.navigate('/');
      });
    }
  },

  watch: {
    //
  }
};
</script>
